import React, { ReactNode } from 'react';
import classnames from 'classnames';
import useStyles from './useStyles';

export interface InlineListItemProps {
  href?: string;
  className?: string;
  children?: ReactNode;
  anchorAttributes?: {
    rel: string;
  } | null;
  isTitle?: boolean;
  lastItem?: boolean;
}

const InlineListItem = ({
  children = '',
  className = '',
  isTitle = false,
  href = '',
  anchorAttributes = null,
  lastItem = false,
  ...rest
}: InlineListItemProps) => {
  const { inlineListItem, inlineListItemBullet, inlineListItemAnchor } =
    useStyles({ isTitle });

  const showBullet = !isTitle && !lastItem;

  const inlineListItemAnchorMerged = classnames(
    inlineListItemAnchor,
    className
  );

  return (
    <li className={inlineListItem} {...rest}>
      <Choose>
        <When condition={!!href}>
          <a
            className={inlineListItemAnchorMerged}
            href={href}
            {...anchorAttributes}
          >
            {children}
          </a>
        </When>
        <Otherwise>{children}</Otherwise>
      </Choose>
      <If condition={showBullet}>
        <span className={inlineListItemBullet}>&bull;</span>
      </If>
    </li>
  );
};

export default InlineListItem;
